import React, { memo } from "react";
import { Platform, StyleSheet } from "react-native";
import styled from "styled-components/native";
import { VDBText } from "..";
import { SvgUri } from "react-native-svg";
import { DefaultTheme } from "styled-components/native";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { SpaceType } from "../Spacer/types";
import { useAIChatBotConfig } from "@redux/slices/globalSlice";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import { useSelector } from "react-redux";

const isWeb = Platform.OS === "web";
const BUTTON_HEIGHT = 48;
const BUTTON_WIDTH = isWeb ? 181 : 167;
const BORDER_WIDTH = 3;

export const ButtonContent = memo(({ typography }: { typography: any }) => {
  const { theme, t } = useScreenOptionsHooks();
  const aiChatBotConfig = useAIChatBotConfig();
  const isCustomApp = useSelector((state: any) => state.appState?.isCustomApp);

  return (
    <ButtonContainer id="widget" isCustomApp={isCustomApp}>
      {/* <AnimatedVDBLogo /> */}
      {isCustomApp ? (
        aiChatBotConfig?.icon?.type === "url" ? (
          <VDBIcon
            name={undefined}
            uri={aiChatBotConfig?.icon?.data}
            size={24}
            color={theme["core-06"]}
            variant={IconsVariant.CustomUrl}
          />
        ) : (
          <VDBIcon
            name={aiChatBotConfig?.icon?.data}
            size={24}
            color={theme["core-06"]}
            variant={IconsVariant.VDBCustom}
          />
        )
      ) : (
        <SvgUri
          uri={
            "https://cdn.vdbapp.com/ai/chat-widget/assets/img/VDB_LOGO_WHITE.svg"
          }
          width={84}
          height={24}
        />
      )}
      <VDBText type={typography} color={theme["diam-05"]} style={styles.text}>
        {isCustomApp ? t(aiChatBotConfig?.label) : "AI Search"}
      </VDBText>
    </ButtonContainer>
  );
});

const ButtonContainer = styled.View<{
  theme: DefaultTheme;
  isCustomApp: boolean;
}>`
  width: ${BUTTON_WIDTH - BORDER_WIDTH * 2}px;
  height: ${BUTTON_HEIGHT - BORDER_WIDTH * 2}px;
  border-radius: ${(BUTTON_HEIGHT - BORDER_WIDTH * 2) / 2}px;
  background-color: ${({ theme }) => theme["main-01"]};
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: ${({ isCustomApp }) => (isCustomApp ? SpaceType.Basic : 2)}px;
`;

const styles = StyleSheet.create({
  text: {
    fontWeight: "500",
    letterSpacing: 0.3,
  },
});
